import { render, staticRenderFns } from "./ApiConfig.vue?vue&type=template&id=19130532&"
import script from "./ApiConfig.vue?vue&type=script&lang=js&"
export * from "./ApiConfig.vue?vue&type=script&lang=js&"
import style0 from "./ApiConfig.vue?vue&type=style&index=0&id=19130532&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports